export default {
  name: 'navigation-links',
  props: {
    header: {
      required: false,
      type: Object,
      default: undefined
    },
    links: {
      required: true,
      type: Array,
      default: []
    }
  },
  computed: {
    locale () {
      return this.$store.getters.getLocale
    },
    validLinks () {
      const result = []
      this.links.forEach((link) => {
        const route = this.getRoute(link.route)
        if (route !== this.$route.path) {
          if (link.hasOwnProperty('langs')) {
            if (link.langs.includes(lang => lang === this.locale)) {
              result.push(link)
            }
          } else {
            result.push(link)
          }
        }
      })
      return result
    },
    headerName () {
      if (typeof this.header.nameI18n === 'string') {
        return this.header.nameI18n
      }

      return this.$helpers.treatName(this.header.nameI18n)[this.locale]
    }
  },
  methods: {
    getRoute(routeName) {
      const fullPath = this.$routeResolver(routeName, this.locale, process.env.BASE_URL)
      const path = new URL(fullPath, process.env.BASE_URL).pathname
      return path
    },

    flagIcon (countryCode) {
      const flag = 'flag-icon-' + countryCode.toLowerCase()
      return 'flag-icon ' + flag
    }
  }
}
